/**
 * FilterSection Component
 * 
 * Wrapper component for a filter section with header and content.
 * Provides consistent spacing and styling for section headers.
 */

import { ReactNode } from 'react';
import { HOME_V2_COLORS } from '../colors';

interface FilterSectionProps {
  /** Section title (displayed uppercase) */
  title: string;
  /** Section content */
  children: ReactNode;
}

export default function FilterSection({ title, children }: FilterSectionProps) {
  return (
    <div className="space-y-3">
      {/* Section Header */}
      <h3
        className="text-xs font-black uppercase tracking-[0.72px]"
        style={{ 
          color: HOME_V2_COLORS.dialogSectionHeader,
          lineHeight: 'normal',
        }}
      >
        {title}
      </h3>
      
      {/* Section Content */}
      <div>
        {children}
      </div>
    </div>
  );
}
